import React from 'react';

export default function SimpleTagIcon({ width = 16, height = 16, fill = '#171C33' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666992 1.33329C0.666992 0.965103 0.965469 0.666626 1.33366 0.666626H8.00033C8.17714 0.666626 8.34671 0.736864 8.47173 0.861888L14.1998 6.58996C14.5723 6.96468 14.7814 7.47159 14.7814 7.99996C14.7814 8.52833 14.5723 9.03523 14.1998 9.40996L14.1984 9.41136L9.41866 14.1911C9.41857 14.1912 9.41875 14.191 9.41866 14.1911C9.23297 14.3769 9.01222 14.5246 8.76954 14.6252C8.52674 14.7259 8.26649 14.7777 8.00366 14.7777C7.74083 14.7777 7.48058 14.7259 7.23778 14.6252C6.99504 14.5246 6.77452 14.3771 6.5888 14.1912C6.58875 14.1912 6.58885 14.1913 6.5888 14.1912L0.862529 8.47164C0.737337 8.34659 0.666992 8.1769 0.666992 7.99996V1.33329ZM2.00033 1.99996V7.72359L7.53146 13.2483L7.53199 13.2488C7.59391 13.3108 7.66743 13.36 7.74836 13.3935C7.8293 13.4271 7.91605 13.4443 8.00366 13.4443C8.09127 13.4443 8.17802 13.4271 8.25895 13.3935C8.33988 13.36 8.41341 13.3108 8.47532 13.2488L13.2542 8.46996C13.2544 8.46975 13.2546 8.46955 13.2548 8.46934C13.3786 8.3445 13.448 8.17579 13.448 7.99996C13.448 7.82412 13.3786 7.65542 13.2548 7.53057C13.2546 7.53037 13.2544 7.53016 13.2542 7.52996L7.72418 1.99996H2.00033Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 4.66667C4 4.29848 4.29848 4 4.66667 4H4.67333C5.04152 4 5.34 4.29848 5.34 4.66667C5.34 5.03486 5.04152 5.33333 4.67333 5.33333H4.66667C4.29848 5.33333 4 5.03486 4 4.66667Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}
